import { createSelector } from 'reselect';
import { AppState } from 'pages/app/state';

const getGridLayoutTypeSelector = (state: AppState) => state.userGrid.layouts;

export const layoutSelector = createSelector(
  getGridLayoutTypeSelector,
  (gridLayout) => gridLayout
);


// WEBPACK FOOTER //
// ./src/components/user-grid/selectors.ts